import { TickerAssetType, TimeFrame } from "../config/tickers";
import { TradingOrder, TradingOrderType, TradingPosition, TradingPositionSide, TradingTickData, TradingTickerBraket } from "../config/trading";
import { EditingAccount } from "./editingAccount";
import { EditingEntryOrder } from "./editingEntryOrder";
import { EditingOrder } from "./editingOrder";
import { EditingStopOrder } from "./editingStopOrder";
import { EditingTargetOrder } from "./editingTargetOrder";
import { TraderConfig } from "./tradingHub";


export class EditingPosition {

    private _config: TraderConfig;
    private _trd: TradingPosition;
    private _account: EditingAccount;
    private _targets: EditingTargetOrder[] = [];
    private _entry: EditingEntryOrder;
    private _stop: EditingStopOrder;
    private _lotSize: number;

    tf?: TimeFrame;
    accountSize: number;
    risk: number;

    start?: number;
    end?: number;
    brakets: TradingTickerBraket[] = [];
    get new() { return this._trd.new; }
    get markPrice() { return this._trd.markPrice; }
    get tid() { return this._trd.ticker.id; }
    get targets() { return this._targets; }
    get long() { return this._trd.side == TradingPositionSide.Long; }
    get trd() { return this._trd; }
    get account() { return this._account; }
    get entry() { return this._entry; }
    get stop() { return this._stop; }
    get canRM() { return this._stop && this.lastTarget };
    get lastTarget() { return this._targets.length == 0 ? null : this._targets[this._targets.length - 1]; }
    get lotSize() { return this._lotSize; }
    get config() { return this._config; }
    get lvg() { return this.trd.lvg; }
    set lvg(v: number) { this.trd.lvg = v; }
    get notionalSize() { return this.entry.size * this.markPrice; }

    constructor(account: EditingAccount, config: TraderConfig, trd: TradingPosition) {
        this._account = account;
        this._config = config;
        this._trd = trd;
        this._lotSize = Math.pow(10, trd.ticker.digits);

        //this.addEntry({
        //    id: 0,
        //    market: true,
        //    price: trd.entry,
        //    type: TradingOrderType.Limit,
        //    closePosition: false
        //});
    }
    private getAccountSize() {
        if (this.account.id == 0)
            return this.config.paperDepo;
        return (this.config.hasExtraDepo ? this.config.extraDepo : 0) + this.account.accountInfo.balance;
    }

    private calcOrderFee(o: EditingOrder) {
        o.fee = Math.abs(o.size * this.trd.comission.maker * o.price);
    }
    private calcPnl(o: EditingOrder, bymark: boolean = false) {
        const price = bymark ? o.pos.markPrice : o.price;
        o.u_pnl = o.size * (price - this.entry.price);
        if (!this.long)
            o.u_pnl *= -1;
        o.r_pnl = o.u_pnl - o.fee - this.entry.fee;
    }


    sortTargets() {
        const sign = this.long ? 1 : -1;
        this._targets = this._targets.sort((t1, t2) => sign * (t1.price - t2.price));
    }

  
    private addUnderlineOrder(order: TradingOrder) {
        if (this.trd.new) {
            this.trd.orders ??= [];
            this.trd.orders.push(order);
        }
    }
    private applyUnderlineOrder(order: EditingOrder) {
        let changed = false;
        if (order.trd.price != order.price) {
            order.trd.price = order.price;
            changed = true;
        }
        if (order.trd.size != order.size) {
            order.trd.size = order.size;
            changed = true;
        }
        order.changed = order.changed || changed;
    }
    private applyUnderline() {
        this.applyUnderlineOrder(this.entry);
        this.applyUnderlineOrder(this.stop);
        this.targets.forEach(x => this.applyUnderlineOrder(x));
    }
    updateMarketPrice(tick: TradingTickData) {
        this.trd.markPrice = tick.price;
    }
    addEntry(order: TradingOrder) {
        this._entry = new EditingEntryOrder(this, order);
        this.addUnderlineOrder(order);
        return this._entry;
    }
    addStop(order: TradingOrder) {
        this._stop = new EditingStopOrder(this, order);
        this.addUnderlineOrder(order);
        return this._stop;
    }

    addTarget(order: TradingOrder) {
        const target = new EditingTargetOrder(this, order);
        target.fix = 100;
        this._targets.push(target);
        this.addUnderlineOrder(order);
        return target;
    }
    restoreState(state: TradingPosition) {

    }
    loadState() {
        return this.trd;
    }
    recalInfo() {
        this.accountSize = this.getAccountSize();
        this.risk = this.config.risk;
        this.sortTargets();

        const sign = this.long ? 1 : -1;
        let lastTarget = this.targets.length - 1;
        if (this.targets.length > 1
            && this.targets[lastTarget].fix != 100
            && this.targets[lastTarget - 1].fix == 100) {
            this.targets[lastTarget - 1].fix = this.targets[lastTarget].fix;
            this.targets[lastTarget].fix = 100;
        }
        let stopSize = 0;
        if (this.new) {
            const riskSize = this.accountSize * this.risk / 100;
            if (this.stop) {
                stopSize = Math.abs(this.stop.price - this.entry.price);
                this.entry.size = (riskSize / stopSize); //in coins
            }
        } else {
            if (this.stop)
                this.stop.size = this.stop.trd.size;
        }

        this.calcOrderFee(this.entry);

        if (this.stop) {
            this.stop.rr = -1;
            this.stop.r_rr = -1;
            this.stop.size = this.entry.size;
            this.calcOrderFee(this.stop);
            this.calcPnl(this.stop);
        }

        let leftSize = this.entry.size;

        if (this.targets.length == 0)
            this.calcPnl(this.entry, true);
        else
            this.entry.u_pnl = 0;
        this.entry.r_pnl = -this.entry.fee;

        this.entry.rr = 0;
        this.entry.r_rr = 0;

        let first = true;
        let totalFee = this.entry.fee;


        this.targets.forEach(t => {

            if (this.stop)
                t.rr = sign * (t.price - this.entry.price) / stopSize;
            else
                t.rr = 0;


            t.size = leftSize * t.fix / 100;

            const pc = t.size / this.entry.size;

            this.calcOrderFee(t);
            this.calcPnl(t);

            totalFee += t.fee;

            t.r_pnl = t.u_pnl - totalFee;
            t.r_rr = t.rr * Math.abs(t.r_pnl / t.u_pnl);

            this.entry.rr += t.rr * pc;
            this.entry.u_pnl += t.u_pnl;

            if (first) {
                first = false;
            } else {
                t.u_pnl = this.entry.u_pnl;
                t.r_pnl = this.entry.u_pnl - totalFee;
            }

            leftSize -= t.size;
            if (this.stop) {
                let stoppnl = leftSize * (this.stop.price - this.entry.price);
                if (this.long)
                    stoppnl *= -1;
                const stopfee = this.account.accountInfo.comission.maker * leftSize * this.stop.price;
                t.stop_pnl = t.r_pnl - stoppnl - stopfee;
            } else {
                t.stop_pnl = 0;
            }

            if (this.trd.ticker.asset == TickerAssetType.FX)
                t.size /= this.lotSize;

        });

        if (this.trd.ticker.asset == TickerAssetType.FX)
            this.entry.size /= this.lotSize;

        this.entry.r_pnl = this.entry.u_pnl - totalFee;
        this.entry.r_rr = this.entry.rr;
        if (this.entry.u_pnl != 0)
            this.entry.r_rr = this.entry.rr * Math.abs(this.entry.r_pnl / this.entry.u_pnl);
        if (this.stop)
            this.stop.r_rr = this.stop.rr - (this.entry.rr - this.entry.r_rr);

        if (this.trd.new)
            this.applyUnderline();
    }
}
